<script setup lang="ts">
import Layout from "@/components/Layout";

const theme = localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches) ? 'dark' : 'light';
localStorage.theme = theme;

if (theme === 'dark') {
  document.documentElement.classList.add('dark')
}
</script>

<template>
  <Layout>
    <router-view></router-view>
  </Layout>
</template>
